export default "__VITE_ASSET__3FWYlaf3__"